import lodash from 'lodash'

export function addToast(msg, appearance) {
    const addToast = lodash.get(window, '__react_toast_provider.current.add')
    addToast(msg ? msg : 'NULL', {
        appearance: appearance ? appearance : 'success',
        autoDismiss: true,
    })
}
